import type { Guest, SeatingTable } from '../types';
import { getCompanion } from './companions';

export type WarningCode = 'overflow' | 'split_couple' | 'couple_unseated' | 'child_alone';
export type WarningLevel = 'error' | 'warning' | 'info';

export interface Warning {
  code: WarningCode;
  level: WarningLevel;
  text: string;
  guestIds: string[];
}

export function getTableWarnings(table: SeatingTable, guestsAtTable: Guest[], allGuests: Guest[]): Warning[] {
  const out: Warning[] = [];

  if (guestsAtTable.length > table.seats) {
    out.push({
      code: 'overflow',
      level: 'error',
      text: `Перебор: ${guestsAtTable.length} из ${table.seats}`,
      guestIds: guestsAtTable.map((g) => g.id),
    });
  }

  for (const g of guestsAtTable) {
    const c = getCompanion(g, allGuests);
    if (!c) continue;
    if (c.table_id && c.table_id !== table.id) {
      out.push({
        code: 'split_couple',
        level: 'warning',
        text: `${g.first_name} и ${c.first_name} за разными столами`,
        guestIds: [g.id, c.id],
      });
    } else if (!c.table_id) {
      out.push({
        code: 'couple_unseated',
        level: 'info',
        text: `${c.first_name} (пара ${g.first_name}) без стола`,
        guestIds: [g.id, c.id],
      });
    }
  }

  const hasChild = guestsAtTable.some((g) => g.age_group === 'child' || g.age_group === 'baby');
  const hasAdult = guestsAtTable.some((g) => !g.age_group || g.age_group === 'adult');
  if (hasChild && !hasAdult) {
    out.push({
      code: 'child_alone',
      level: 'warning',
      text: 'Дети без взрослых',
      guestIds: guestsAtTable.map((g) => g.id),
    });
  }

  return out;
}

export function countAllWarnings(
  tables: SeatingTable[],
  guestsByTable: Map<string, Guest[]>,
  allGuests: Guest[],
): number {
  let n = 0;
  for (const t of tables) n += getTableWarnings(t, guestsByTable.get(t.id) || [], allGuests).length;
  return n;
}
